<template>
  <template v-for="(item,index) in messages.messages " :key="index">
    <div :class="['alert', 'alert-' + Object.keys(item)[0]]"><span v-html="Object.values(item)[0].replace(/\n/g, '<br>')" /></div>
  </template>
</template>

<script setup>
import { useStoreMessages } from '@/stores/messages'
const messages = useStoreMessages()
</script>